[
  {
    "code": "AD-07",
    "name": "Andorra la Vella"
  },
  {
    "code": "AD-02",
    "name": "Canillo"
  },
  {
    "code": "AD-03",
    "name": "Encamp"
  },
  {
    "code": "AD-08",
    "name": "Escaldes-Engordany"
  },
  {
    "code": "AD-04",
    "name": "La Massana"
  },
  {
    "code": "AD-05",
    "name": "Ordino"
  },
  {
    "code": "AD-06",
    "name": "Sant Julià de Lòria"
  }
]